import { SENTIMENT } from "@/constants";
import newTheme from "@/new_theme";

const DARK_CHART_COLORS = [
  newTheme["primary-700"],
  newTheme["blue-400"],
  newTheme["pink-300"],
  newTheme["blue-700"],
  newTheme["pink-400"],
  newTheme["primary-300"],
  newTheme["pink-700"],
  newTheme["primary-400"],
  newTheme["blue-300"],
];

export const CHART_COLORS = [
  newTheme["blue-600"],
  newTheme["primary-800"],
  newTheme["pink-300"],
  newTheme["primary-100"],
  newTheme["blue-500"],
  newTheme["pink-500"],
  newTheme["primary-300"],
  newTheme["blue-100"],
  newTheme["pink-700"],
  newTheme["primary-400"],
  newTheme["blue-300"],
  newTheme["pink-200"],
];

export const CHART_COLORS_LIGHTER = {
  [newTheme["blue-600"]]: "#73A3D9",
  [newTheme["blue-500"]]: "#8FBBED",
  [newTheme["blue-300"]]: "#D0EBFF",
  [newTheme["blue-100"]]: "#F1F9FF",
  [newTheme["primary-800"]]: "#8756B7",
  [newTheme["primary-400"]]: "#D0B7F8",
  [newTheme["primary-300"]]: "#DAC5FB",
  [newTheme["primary-100"]]: "#F2EAFF",
  [newTheme["pink-700"]]: "#BE60A3",
  [newTheme["pink-500"]]: "#DBA3CB",
  [newTheme["pink-300"]]: "#F3DCED",
  [newTheme["pink-200"]]: "#FAEBF6",
};

export const CHART_SENTIMENT_COLORS = {
  [SENTIMENT.VERY_POSITIVE]: newTheme["sentiment-very-positive"],
  [SENTIMENT.POSITIVE]: newTheme["sentiment-positive"],
  [SENTIMENT.NEGATIVE]: newTheme["sentiment-negative"],
  [SENTIMENT.VERY_NEGATIVE]: newTheme["sentiment-very-negative"],
  [SENTIMENT.NEUTRAL]: newTheme["gray-500"],
};

const assignedColors: Record<string, Record<string, string>> = {};

interface GetColorOptions {
  title?: string | null;
  dark?: boolean;
  scope?: string | null;
  transparent?: boolean;
}

export const getColor = (
  idx = 0,
  {
    title = null,
    dark = false,
    scope = null,
    transparent = false,
  }: GetColorOptions = {}
): string => {
  const set = dark ? DARK_CHART_COLORS : CHART_COLORS;
  let color = set[idx % set.length];

  if (title) {
    const key = scope ?? "default";

    // create scope unless it exists
    if (!assignedColors[key]) {
      assignedColors[key] = {};
    }

    // get color if already set once
    if (assignedColors[key][title]) {
      color = assignedColors[key][title];
    }
    // find and store color for scope and title
    else {
      const index = Object.keys(assignedColors[key]).length;
      color = set[index % set.length];
      assignedColors[key][title] = color;
    }
  }

  if (transparent) {
    color = `${color}aa`;
  }

  return color;
};
